import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Settings } from '@mui/icons-material';
import { Box, Button, Drawer } from '@mui/material';
import { handleLogout } from '../../../utils/logout';

import useResponsive from '../../../hooks/useResponsive';
import Scrollbar from '../../../components/scrollbar';
import NavSection from '../../../components/nav-section';
import navConfig from './config';

const NAV_WIDTH = 280;

Nav.propTypes = {
  openNav: PropTypes.bool,
  onCloseNav: PropTypes.func,
};

export default function Nav({ openNav, onCloseNav }) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const isDesktop = useResponsive('up', 'lg');

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      navigate('/dashboard/message');
    }
  };

  useEffect(() => {
    if (openNav) onCloseNav();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        background: 'linear-gradient(180deg, #9f1d21 0%, #9f1d21 100%)',
        height: 1,
        '& .simplebar-content': { height: 1, display: 'flex', flexDirection: 'column' },
      }}
    >
      <div
        role="button"
        tabIndex={0}
        onClick={() => navigate('/dashboard/message')}
        onKeyDown={handleKeyDown}
        style={{ cursor: 'pointer' }}
      >
        <img
          src="https://myraceindia.com/assets/logos/header-logo.png"
          alt="logo"
          style={{
            height: '40px',
            width: 'auto',
            objectFit: 'contain',
            marginTop: '10px',
            objectPosition: 'left',
            marginLeft: '1.5rem',
          }}
        />
      </div>

      <div style={{ color: 'white', borderBottom: '1px  solid', margin: '1rem 0' }} />
      <NavSection data={navConfig} />
      <Box sx={{ flexGrow: 1 }} />
      <Box p={2}>
        <Button
          variant="outlined"
          sx={{
            width: '100%',
            height: '50px',
            color: 'white',
            border: 'none !important',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'start',
            gap: 1,
          }}
          onClick={() => navigate('/dashboard/setting')}
        >
          <Settings />
          Settings
        </Button>
        <Button
          variant="outlined"
          sx={{
            width: '100%',
            height: '50px',
            color: 'white',
            borderColor: 'white !important',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
          onClick={handleLogout}
        >
          Logout
          <svg width="25px" height="25px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="SVGRepo_bgCarrier" strokeWidth="0" />
            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
            <g id="SVGRepo_iconCarrier">
              {' '}
              <path
                opacity="0.5"
                d="M15.9998 2L14.9998 2C12.1714 2 10.7576 2.00023 9.87891 2.87891C9.00023 3.75759 9.00023 5.1718 9.00023 8.00023L9.00023 16.0002C9.00023 18.8287 9.00023 20.2429 9.87891 21.1215C10.7574 22 12.1706 22 14.9976 22L14.9998 22L15.9998 22C18.8282 22 20.2424 22 21.1211 21.1213C21.9998 20.2426 21.9998 18.8284 21.9998 16L21.9998 8L21.9998 7.99998C21.9998 5.17157 21.9998 3.75736 21.1211 2.87868C20.2424 2 18.8282 2 15.9998 2Z"
                fill="#ffffff"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.75 12C15.75 11.5858 15.4142 11.25 15 11.25L4.02744 11.25L5.98809 9.56943C6.30259 9.29986 6.33901 8.82639 6.06944 8.51189C5.79988 8.1974 5.3264 8.16098 5.01191 8.43054L1.51191 11.4305C1.34567 11.573 1.25 11.781 1.25 12C1.25 12.2189 1.34567 12.4269 1.51191 12.5694L5.01191 15.5694C5.3264 15.839 5.79988 15.8026 6.06944 15.4881C6.33901 15.1736 6.30259 14.7001 5.98809 14.4305L4.02744 12.75L15 12.75C15.4142 12.75 15.75 12.4142 15.75 12Z"
                fill="#ffffff"
              />
            </g>
          </svg>
        </Button>
      </Box>
    </Scrollbar>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV_WIDTH },
      }}
    >
      {isDesktop ? (
        <Drawer
          open
          variant="permanent"
          PaperProps={{
            sx: {
              width: NAV_WIDTH,
              bgcolor: 'background.default',
              borderRightStyle: 'dashed',
            },
          }}
        >
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            sx: { width: NAV_WIDTH },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}
